import { NavLink } from 'react-router';
import More from '@/assets/images/icons/more.svg?react';
import { useIsDesktop } from '@/hooks/use-user-platform';
import type { ConversationType } from '@/models/conversations/conversation-session';
import ROUTES from '@/routes';
import cn from '@/utils/merge-class-names';

interface SessionSettingMenuProps {
  type: ConversationType;
  id: number;
}

export default function SessionSettingMenu({ type, id }: SessionSettingMenuProps) {
  const isDesktop = useIsDesktop();
  const parentPath = type === 'session' ? ROUTES.MESSAGES.SESSIONS : ROUTES.MESSAGES.GROUPS;

  if (!isDesktop) return null;

  return (
    <NavLink
      className={({ isActive }) => cn('relative btn btn-ghost inline-flex', { 'bg-base-100': isActive })}
      to={parentPath.SETTINGS.$buildPath({ params: { id } })}>
      <More className='size-4 rotate-90' />
    </NavLink>
  );
}
